import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from './images/search.svg';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: 300,
    height: 54,
    background: '#fff',
    borderRadius: '3px !important',
    boxShadow: 'none',
    [theme.breakpoints.down('sm')]: {
      width: 260,
    },
    [theme.breakpoints.down('600')]: {
      width: '100%',
    },
  },
  input: {
    flex: 1,
    color: theme.palette.text.primary,
    fontSize: '1.0625rem',
    fontFamily: 'MadaMedium',
    lineHeight: '23px',
    padding: 0,
    '& ::placeholder': {
      fontFamily: 'MadaRegular',
    },
    '& input': {
      padding: 0,
    },
  },
  iconButton: {
    padding: 16,
  },
}));

function SearchBox({ handleFocus, searchRef, value, searchTopic }) {
  const classes = useStyles();

  return (
    <Paper component="form" className={classes.root} ref={searchRef}>
      <IconButton
        className={classes.iconButton}
        aria-label="Search"
        onClick={handleFocus}
      >
        <img src={SearchIcon} alt="Search" />
      </IconButton>
      <InputBase
        className={classes.input}
        onFocus={handleFocus}
        onChange={searchTopic}
        onClick={handleFocus}
        placeholder="Enter topics or categories..."
        inputProps={{ 'aria-label': 'enter topics or categories' }}
        value={value}
      />
    </Paper>
  );
}

SearchBox.propTypes = {
  searchRef: PropTypes.any,
  handleFocus: PropTypes.func,
  value: PropTypes.string,
  searchTopic: PropTypes.func,
};

export default SearchBox;
